export default __webpack_public_path__ + "static/media/Apple (2).aab4799c.jpg";